import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";

export default function SortOptions(props) {
    const {
        activeSort,
        localStorageKey,
        isDesktop,
        sortOptions,
        sortGamesOnClick,
        defaultCategorySort,
        positionLeft,
    } = props;

    const [sortMenuIsActive, setSortMenuIsActive] = useState(false);
    const sortMenuRef = useRef(null);

    const activeSortId = useMemo(() => {
        const storedSortId = localStorage.getItem(localStorageKey);
        return storedSortId !== null ? parseInt(storedSortId) : activeSort;
    }, [activeSort, localStorageKey]);

    const handleOutsideClick = (event) => {
        if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
            setSortMenuIsActive(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        }
    }, [handleOutsideClick]);

    const sortMenuOnClick = useCallback(() => {
        setSortMenuIsActive((prevState) => !prevState);
    }, []);

    const renderSort = useCallback(
        (sortItem, index) => {
            const isActive = activeSortId === sortItem.id;
            const isHidden =
                !sortItem.alwaysVisible && defaultCategorySort !== 1 && activeSortId !== 1;

            return (
                <button
                    className={`${isActive ? "active" : ""} ${isHidden ? "hidden" : ""}`}
                    key={`sort_${sortItem.id}`}
                    id={`sort_${sortItem.id}`}
                    onClick={() => sortGamesOnClick(sortItem.id)}
                >
                    <span className="icon"></span>
                    {sortItem.name}
                </button>
            );
        },
        [activeSortId, defaultCategorySort, sortGamesOnClick]
    );

    const activeSortName = useMemo(() => {
        return sortOptions?.find((x) => x.id === activeSortId)?.name || "Sortiraj igre";
    }, [activeSortId, sortOptions]);

    return (
        <div
            onClick={sortMenuOnClick}
            className={"game-sort-container" + (!isDesktop ? " mobile" : "")}
            ref={sortMenuRef}
        >
            <div className="sort-button">
                <span className="icon"></span>
                <div className="title">{activeSortName}</div>
            </div>
            <div className={`list${sortMenuIsActive ? (positionLeft ? " left" : "") : " hidden"}`}>
                {isDesktop && <div className="arrow-element"></div>}
                <ul className="sort_game_drop_down_list">
                    {sortOptions?.map((sortItem, index) => 
                        renderSort(sortItem, activeSortId, index)
                    )}
                </ul>
            </div>
        </div>
    );
};

